import React, { memo } from 'react'

import type { CustomTooltipContentProps } from './TooltipContent'
import TooltipContent from './TooltipContent'

export type CustomTooltipProps = CustomTooltipContentProps & {
  off?: boolean
}

const Tooltip = ({ off = false, children, ...rest }: CustomTooltipProps) =>
  off ? children : <TooltipContent {...rest}>{children}</TooltipContent>

export default memo(Tooltip)
